import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node) => {
  const megamenus: NodeListOf<HTMLElement> = node.querySelectorAll('.header-megamenu');

  document.addEventListener('click', (event: MouseEvent | TouchEvent) => {
    if (!(event.target instanceof Node)) {
      return;
    }

    megamenus.forEach((megamenu) => {
      if (
        !megamenu.contains(<HTMLElement>event.target) &&
        !megamenu.nextElementSibling.isEqualNode(<HTMLElement>event.target)
      ) {
        event.stopPropagation();
        megamenu.classList.remove('active');
        node.classList.remove('menu-active');
      }
    });
  });

  megamenus.forEach((megamenu) => {
    megamenu.nextElementSibling.addEventListener('click', () => {
      megamenu.classList.toggle('active');
      node.classList.toggle('menu-active');
    });
  });

  document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`);
  window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`);
  });
};

export default Component;
